import { render, staticRenderFns } from "./Companies.vue?vue&type=template&id=16209667&"
import script from "./Companies.vue?vue&type=script&lang=ts&"
export * from "./Companies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports